import {useUser} from "@/biz/user.mjs"
import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import http from '@/biz/http.mjs'

export const isProjectMember = (userId, members, role) => {
    const m = members.find(e => e.userId === userId)

    if (! m) {
        return false
    }

    if (! m.prjGrpTypeCode) {
        return false
    }

    if (! role) {
        return true
    }

    const re = new RegExp(`\b${role}\b`)
    return re.test(m.prjGrpTypeCode)
}

export const readProjectMembers = prjId => http.get('/prjmbrs', {prjId})

export const useIsProjectMember = (prjId, role) => {
    const user = useUser()
    const {data: members} = useProjectMembers(prjId)

    if (! (user && members)) {
        return false
    }

    return isProjectMember(user.pkid, members, role)
}

export const useProjectMembers = prjId => {
    return useSwrNoCache(
        () => readProjectMembers(prjId),

        {
            dependencies: [prjId],
            start: void 0 !== prjId,
        }
    )
}
